/**
 * MenuMask component
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Props for the mask menu.
 */
interface Props {
  collapse: boolean;
}

/**
 * Gradient mask on the left (menu side). Shown when menu is expanded (!collapse).
 */
const MenuMask = styled.div<Props>`
  background: linear-gradient(263deg, rgba(1, 1, 1, 0) 49.66%, #010101 86.81%);
  height: ${1080 * Screen.widthRatio}px;
  left: 0;
  position: absolute;
  top: 0;
  width: ${646 * Screen.widthRatio}px;
  z-index: 1;
`;

export default withOpacity(MenuMask);
